import { c as _c } from "react/compiler-runtime";
/* eslint-disable jsx-a11y/alt-text */
import { mergeClasses } from '@/utils/style';
import { motion } from 'framer-motion';
import Image from 'next/image';
import { useRef } from 'react';
import { useCardScroll } from './useCardScroll';
import { Card, StackCardsProps } from './types';
export function CardImageOnRight(props) {
  const $ = _c(33);
  const {
    totalCards,
    index,
    setActiveTab,
    description,
    footer,
    images,
    title
  } = props;
  const ref = useRef(null);
  let t0;
  if ($[0] !== index || $[1] !== setActiveTab || $[2] !== totalCards) {
    t0 = {
      totalCards,
      index,
      setActiveTab,
      ref
    };
    $[0] = index;
    $[1] = setActiveTab;
    $[2] = totalCards;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const {
    isMobile,
    transform
  } = useCardScroll(t0);
  const t1 = index === 0 && "mb-[36px] md:mb-[42px]";
  const t2 = index === 1 && "top-[93px] mb-[24px] md:top-[164px] md:mb-[28px]";
  const t3 = index === 2 && "top-[80px] mb-[12px] md:top-[190px] md:mb-[14px]";
  const t4 = index === 3 && "top-[95px] mb-0 md:top-[205px]";
  let t5;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
    t5 = mergeClasses("shadow-floating sticky top-[80px] h-[435px] origin-[50%_0%] rounded-2xl bg-white p-4 md:h-[560px]", "md:top-[150px] md:rounded-[40px]", t1, t2, t3, t4);
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== transform) {
    t6 = {
      scaleX: transform,
      scaleY: transform
    };
    $[9] = transform;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      scaleX: 1,
      scaleY: 1
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== title) {
    t8 = <h3 className="mt-6 mb-2 text-lg font-bold text-gray-900 md:mt-0 md:mb-6 md:text-5xl" data-analytics-param="cardContent">{title}</h3>;
    $[12] = title;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== description) {
    t9 = description && <div className="text-sm text-gray-800 md:text-xl">{description}</div>;
    $[14] = description;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== footer) {
    t10 = footer && <div className="mt-auto pb-1 md:mt-16">{footer}</div>;
    $[16] = footer;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t8 || $[20] !== t9) {
    t11 = <div className="flex flex-2 flex-col pr-0 pl-0 md:pr-1 md:pl-14">{t8}{t9}{t10}</div>;
    $[18] = t10;
    $[19] = t8;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const t12 = isMobile ? images.mobile : images.desktop;
  const t13 = isMobile ? 280 : 530;
  const t14 = isMobile ? 210 : 560;
  let t15;
  if ($[22] !== t12 || $[23] !== t13 || $[24] !== t14) {
    t15 = <div className="h-[160px] w-full overflow-hidden rounded-2xl bg-blue-100 md:h-full md:w-[initial] md:rounded-[1.25rem]"><Image className="flex-1 overflow-auto object-[0_-70px] md:object-top" {...t12} width={t13} height={t14} sizes="100vw" /></div>;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t11 || $[27] !== t15) {
    t16 = <div className="flex h-[408px] flex-col-reverse items-center overflow-hidden rounded-2xl md:h-[528px] md:flex-row md:rounded-[1.25rem] md:bg-blue-100">{t11}{t15}</div>;
    $[26] = t11;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t16 || $[30] !== t5 || $[31] !== t6) {
    t17 = <motion.article ref={ref} className={t5} style={t6} initial={t7}>{t16}</motion.article>;
    $[29] = t16;
    $[30] = t5;
    $[31] = t6;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  return t17;
}